import React from "react";

interface StarIconProps {
  className?: string;
  filled?: boolean;
}

export const StarIcon: React.FC<StarIconProps> = ({
  className = "",
  filled = false,
}) => {
  return (
    <div style={{ padding: "4px" }}>
      {filled ? (
        <svg
          className={className}
          width="24"
          height="24"
          viewBox="0 0 7 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.28976 0.1L3.1671 2.22333L1.04309 0.0993334C0.979585 0.0372265 0.89418 0.00261708 0.805351 0.00299136C0.716522 0.00336564 0.631411 0.0386934 0.568428 0.101333L0.101761 0.568666C0.069815 0.599311 0.0443472 0.636059 0.026868 0.67673C0.00938877 0.717402 0.000253912 0.761168 5.21845e-06 0.805436C-0.000243475 0.849703 0.00839916 0.89357 0.0254203 0.934435C0.0424415 0.9753 0.0674949 1.01233 0.0990948 1.04333L2.22243 3.166L0.0997615 5.29C0.0377428 5.3536 0.00325285 5.43905 0.00375189 5.52788C0.00425093 5.61671 0.0396987 5.70177 0.102428 5.76467L0.569095 6.23133C0.706428 6.36933 0.913095 6.36467 1.04376 6.234L3.16776 4.11067L5.29043 6.234C5.35402 6.29602 5.43948 6.33051 5.52831 6.33001C5.61714 6.32951 5.7022 6.29406 5.7651 6.23133L6.23243 5.76467C6.26433 5.73398 6.28975 5.69719 6.30717 5.6565C6.32459 5.6158 6.33366 5.57202 6.33385 5.52776C6.33404 5.48349 6.32533 5.43963 6.30826 5.39879C6.29118 5.35795 6.26607 5.32096 6.23443 5.29L4.11043 3.166L6.23443 1.04333C6.29654 0.979824 6.33115 0.894418 6.33077 0.80559C6.3304 0.716761 6.29507 0.63165 6.23243 0.568666L5.76576 0.102C5.73448 0.0699816 5.69717 0.0444815 5.65597 0.0269737C5.61478 0.00946597 5.57052 0.000298057 5.52576 0C5.48188 0.000358737 5.43851 0.00937684 5.39813 0.0265373C5.35774 0.0436977 5.32114 0.0686628 5.29043 0.1H5.28976Z"
            fill="currentColor"
          />
        </svg>
      ) : (
        <svg
          className={className}
          width="24"
          height="24"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.6728 11.6281L17.3458 8.0481L12.2698 7.3101L9.99985 2.7111L7.72985 7.3111L2.65385 8.0481L6.32685 11.6281L5.45985 16.6831L9.99985 14.2971L14.5398 16.6831L13.6728 11.6281V11.6281ZM9.99985 16.6261L5.49485 18.9961C5.23947 19.1306 4.95153 19.1909 4.66365 19.1702C4.37576 19.1495 4.09941 19.0487 3.86589 18.879C3.63236 18.7094 3.45098 18.4778 3.34229 18.2104C3.23359 17.943 3.20192 17.6506 3.25085 17.3661L4.11085 12.3491L0.466848 8.7961C0.260273 8.59473 0.114161 8.33958 0.045037 8.0595C-0.0240874 7.77942 -0.0134668 7.48558 0.0756974 7.21123C0.164862 6.93687 0.329012 6.69293 0.549586 6.507C0.77016 6.32106 1.03836 6.20056 1.32385 6.1591L6.36085 5.4271L8.61285 0.863104C8.74038 0.604076 8.9379 0.385936 9.18304 0.233393C9.42817 0.0808503 9.71113 0 9.99985 0C10.2886 0 10.5715 0.0808503 10.8167 0.233393C11.0618 0.385936 11.2593 0.604076 11.3868 0.863104L13.6388 5.4271L18.6758 6.1591C18.9613 6.20056 19.2295 6.32106 19.4501 6.507C19.6707 6.69293 19.8348 6.93687 19.924 7.21123C20.0132 7.48558 20.0238 7.77942 19.9547 8.0595C19.8855 8.33958 19.7394 8.59473 19.5328 8.7961L15.8878 12.3491L16.7478 17.3651C16.7966 17.6494 16.7649 17.9417 16.6563 18.209C16.5476 18.4762 16.3663 18.7077 16.133 18.8773C15.8996 19.0468 15.6235 19.1478 15.3357 19.1686C15.048 19.1894 14.7602 19.1293 14.5048 18.9951L9.99985 16.6261Z"
            fill="currentColor"
          />
        </svg>
      )}
    </div>
  );
};
